import { IMainPlatforms } from '../../../../../model/briefing/step1/IMainPlatforms';
import { User } from '../../../../../model/user/User';
import { IAudiencesManual } from '../../../../../authentication/social/dto/IAudiencesManual';
import { IDefault } from '../../../../../model/shared/IDefault';
import { Platforms } from '../../../../../model/platform/Platforms';
import { ICollaboration } from '../../../../../model/shared/ICollaboration';

export enum MoodashGender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
    KNOWN = 'KNOWN',
    UNKNOWN = 'UNKNOWN',
}

export enum AudienceGender {
    MALE = 'MALE',
    FEMALE = 'FEMALE',
}

export enum MoodashActivePlatforms {
    INSTAGRAM = 'Instagram',
    TIKTOK = 'TikTok',
    YOUTUBE = 'YouTube',
}

interface Range {
    min?: number;
    max?: number;
}

interface FollowersGrowthRate {
    interval: string;
    value: number;
    operator: string;
}

interface ContactDetail {
    contactType: string;
    filterAction: string;
}

export interface TextTag {
    type: string;
    value: string;
}

interface FilterOperation {
    operator: string;
    filter: string;
}

interface AudienceLocation {
    id: number;
    weight: number;
}

interface AudienceAttribute {
    id: string | number;
    weight: number;
}

export interface IFavoritesCount {
    favoritesCount: number;
    filters: IDiscoveryFilterPlatform;
    uiDefaults: IUiDefaultPlatforms;
}

export interface IFavoritesFilter {
    page: number;
    perPage: number;
    sortType?: null | string;
    sortBy?: null | string;
    isGlobal?: boolean;
    search?: string;
    brandUsername?: string;
}

export interface IAddFavoriteUserRequest {
    externalId?: number;
    campaignId: number;
    ivId?: number;
}

interface DiscoveryInfluencerFilter {
    followers?: Range;
    engagementRate?: number;
    location?: number[];
    language?: string;
    lastposted?: string;
    relevance?: string[];
    gender?: MoodashGender;
    age?: Range;
    followersGrowthRate?: FollowersGrowthRate;
    bio?: string;
    hasYouTube?: boolean;
    hasContactDetails?: ContactDetail[];
    accountTypes?: number[];
    brands?: number[];
    interests?: number[];
    keywords?: string;
    textTags?: TextTag[];
    reelsPlays?: Range;
    views?: Range;
    isVerified?: boolean;
    hasSponsoredPosts?: boolean;
    engagements?: Range;
    filterOperations?: FilterOperation[];
}

interface AudienceFilter {
    location?: AudienceLocation[];
    language?: AudienceAttribute;
    gender?: AudienceAttribute;
    age?: AudienceAttribute[];
    interests?: AudienceAttribute[];
    credibility?: number;
}

export interface IDiscoveryFilterPlatform {
    [key: string]: any;

    instagram: IDiscoveryFilter;
    youtube: IDiscoveryFilter;
    tiktok: IDiscoveryFilter;
}

export interface IDiscoveryFilter {
    influencer?: DiscoveryInfluencerFilter;
    audience?: AudienceFilter;
}

export interface DiscoveryResponse {
    directs?: DiscoveryUser[];
    lookalikes: DiscoveryUser[];
    total: number;
    info: { isClient: boolean };
}

export interface DiscoveryProfile {
    engagementRate: number;
    engagements: number;
    averageViews: number;
    followers: number;
    fullname: string;
    url: string;
    username: string;
    isVerified: boolean;
    isPrivate: boolean;
    isFavorite: boolean;
    picture: string;
    externalId: number;
    ivId: number;
    ivProfileId: number;
}

export interface DiscoveryFavoriteProfile {
    id: number;
    engagementRate: number;
    engagements: number;
    followers: number;
    fullName: string;
    photoUrl: string;
    platform: string;
    title: string;
    mainPlatform: IMainPlatforms;
    ivId: number;
    externalId: number;
    ivProfileId: number;
    hasOffer?: boolean;
    offerId?: number;
    isContacted?: boolean;
    requestStatus?: string;
    isDeclined?: boolean;
    topAudienceCountry?: string;
    audiences?: IAudiencesManual[];
}

export interface DiscoveryFavoriteResponse {
    id: number;
    note: string;
    clientNote: string;
    externalUser: DiscoveryFavoriteProfile;
    internalUser: DiscoveryFavoriteProfile;
    reaction: IReactionsResponse;
    editedBy?: User;
    clientEditedBy?: User;
    alreadyViewed?: boolean;
    priority?: string;
    email?: string;
    price?: number;
    influencerPurchaseOrder?: string;
    collaboration?: ICollaboration;
}

export interface IReactionsResponse {
    dislikes: number;
    likes: number;
    userReaction: DiscoveryReactionEnum;
}

export interface IProfileIds {
    ivId?: number;
    externalId?: number;
    ivProfileId?: number;
    offerId?: number;
    isFavorite?: boolean;
}

export interface DiscoveryUser {
    userId: string;
    isSaved: boolean;
    hasOffer: boolean;
    offerId?: number;
    profile: DiscoveryProfile;
    alreadyViewed: boolean;
    listCount?: number;
}

export const lastPost = ['30', '60', '90'];
export const fakeFollowersArr = [
    { name: '≤ 25%', value: 0.75 },
    { name: '≤ 35%', value: 0.65 },
    { name: '≤ 50%', value: 0.5 },
];
export const engagementRateArr = [
    { name: '≥ 0.5%', value: 0.005 },
    { name: '≥ 1%', value: 0.01 },
    { name: '≥ 2% (average)', value: 0.02 },
    { name: '≥ 3%', value: 0.03 },
    { name: '≥ 4%', value: 0.04 },
    { name: '≥ 5%', value: 0.05 },
    { name: '≥ 6%', value: 0.06 },
    { name: '≥ 7%', value: 0.07 },
    { name: '≥ 8%', value: 0.08 },
    { name: '≥ 9%', value: 0.09 },
    { name: '≥ 10%', value: 0.1 },
];
export const audiencePercentages = [
    { name: '≥ 5%', value: 0.05 },
    { name: '≥ 10%', value: 0.1 },
    { name: '≥ 15%', value: 0.15 },
    { name: '≥ 20%', value: 0.2 },
    { name: '≥ 25%', value: 0.25 },
    { name: '≥ 30%', value: 0.3 },
    { name: '≥ 35%', value: 0.35 },
    { name: '≥ 40%', value: 0.4 },
    { name: '≥ 45%', value: 0.45 },
    { name: '≥ 50%', value: 0.5 },
    { name: '≥ 55%', value: 0.55 },
    { name: '≥ 60%', value: 0.6 },
    { name: '≥ 65%', value: 0.65 },
    { name: '≥ 70%', value: 0.7 },
    { name: '≥ 75%', value: 0.75 },
    { name: '≥ 80%', value: 0.8 },
    { name: '≥ 85%', value: 0.85 },
    { name: '≥ 90%', value: 0.9 },
    { name: '≥ 95%', value: 0.95 },
];

export enum growthInterval {
    i1 = 'i1month',
    i2 = 'i2months',
    i3 = 'i3months',
    i4 = 'i4months',
    i5 = 'i5months',
    i6 = 'i6months',
}

export enum growthOperator {
    GTE = 'gte',
    GT = 'gt',
    LT = 'lt',
    LTE = 'lte',
}

export const growthValue = [
    { name: '10%', value: 0.1 },
    { name: '20%', value: 0.2 },
    { name: '30%', value: 0.3 },
    { name: '40%', value: 0.4 },
    { name: '50%', value: 0.5 },
    { name: '150%', value: 1.5 },
    { name: '200%', value: 2 },
    { name: '300%', value: 3 },
    { name: '400%', value: 4 },
];

export const AudienceAge = ['13-17', '18-24', '25-34', '35-44', '45-64', '65-'];
export const DEFAULT_AUDIENCE_WEIGHT = 0.2;

export enum FavoritesSortType {
    FOLLOWERS = 'followers',
    ENGAGEMENTS = 'engagements',
    ENGAGEMENT_RATE = 'engagementRate',
    REACTIONS = 'reactions',
    PRIORITY = 'priority',
}

export enum DiscoveryReactionEnum {
    LIKE = 'like',
    DISLIKE = 'dislike',
}

export interface IDiscoveryReaction {
    listId: number;
    reaction: DiscoveryReactionEnum;
}

export interface IDiscoveryDetails {
    discoveryProfilePrice?: number;
    discoveryProfileTokensLeft?: number;
    discoveryProfileViewsLeft?: number;
}

export interface SaveCurrentFilter {
    campaignId: number;
    platformName: string;
    filter?: IDiscoveryFilter;
    uiDefaults?: IUiDefaultState;
}

export interface IUiDefaultPlatforms {
    [key: string]: any;

    instagram: IUiDefaultState;
    youtube: IUiDefaultState;
    tiktok: IUiDefaultState;
}

export interface IUiDefaultState {
    influencer?: any;
    audience?: any;
}

export interface IDiscoveryListTotals {
    avgEngagementRate: number;
    discoveryListId: number;
    dislikes: number;
    likes: number;
    listCount: number;
    noteCount: number;
    topCountries: [];
    totalAverageViews: number;
    totalFollowers: number;
    impressions: number;
}

export interface IDiscoveryList {
    avgEngagementRate: number;
    discoveryListId: number;
    dislikes: number;
    likes: number;
    listCount: number;
    noteCount: number;
    topCountries: [];
    totalAverageViews: number;
    totalFollowers: number;
    impressions: number;
}

export interface IDiscoveryPreSetData extends IDefault {
    isPreSet: boolean;
    isGlobal: boolean;
    platform: Platforms;
    title: string;
    filterData: IDiscoveryFilter;
    uiDefaults: IUiDefaultState;
}

export const defaultInfluencer = {
    mentions: [],
    hashtags: [],
    location: [],
    interests: [],
    topics: [],
    usernames: [],
};
export const defaultAudience = {
    location: [],
};
export const initialFilterState: IDiscoveryFilterPlatform = {
    instagram: {
        audience: { ...defaultAudience },
        influencer: { ...defaultInfluencer },
    },
    youtube: {
        audience: { ...defaultAudience },
        influencer: { ...defaultInfluencer },
    },
    tiktok: {
        audience: { ...defaultAudience },
        influencer: { ...defaultInfluencer },
    },
};
